var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 12.875V3.125H3V12.875C3 14.2557 4.11928 15.375 5.5 15.375H7.375C5.99428 15.375 4.875 14.2557 4.875 12.875Z",
    fill: "#CEE1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 2.5H1.75C1.40481 2.5 1.125 2.77981 1.125 3.125C1.125 3.47019 1.40481 3.75 1.75 3.75H2.375V12.875C2.375 14.5981 3.77688 16 5.5 16H10.5C12.2231 16 13.625 14.5981 13.625 12.875V3.75H14.25C14.5952 3.75 14.875 3.47019 14.875 3.125C14.875 2.77981 14.5952 2.5 14.25 2.5ZM12.375 12.875C12.375 13.9089 11.5339 14.75 10.5 14.75H5.5C4.46613 14.75 3.625 13.9089 3.625 12.875V3.75H12.375V12.875Z",
    fill: "#522E92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 1.25H6.75C6.40481 1.25 6.125 0.970187 6.125 0.625C6.125 0.279813 6.40481 0 6.75 0H9.25C9.59519 0 9.875 0.279813 9.875 0.625C9.875 0.970187 9.59519 1.25 9.25 1.25Z",
    fill: "#EE1451"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.25C7.65481 12.25 7.375 11.9702 7.375 11.625V6.875C7.375 6.52981 7.65481 6.25 8 6.25C8.34519 6.25 8.625 6.52981 8.625 6.875V11.625C8.625 11.9702 8.34519 12.25 8 12.25Z",
    fill: "#522E92"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.25C10.1548 12.25 9.875 11.9702 9.875 11.625V6.875C9.875 6.52981 10.1548 6.25 10.5 6.25C10.8452 6.25 11.125 6.52981 11.125 6.875V11.625C11.125 11.9702 10.8452 12.25 10.5 12.25Z",
    fill: "#522E92"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12.25C5.15481 12.25 4.875 11.9702 4.875 11.625V6.875C4.875 6.52981 5.15481 6.25 5.5 6.25C5.84519 6.25 6.125 6.52981 6.125 6.875V11.625C6.125 11.9702 5.84519 12.25 5.5 12.25Z",
    fill: "#522E92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.14bbc448c25b8091cbe36bd03480cc29.svg";
export { ForwardRef as ReactComponent };